<template>
  <div style="z-index: 3">
    <svg class="button" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" version="1.1"
      width="100%" height="100%" :class="[disabled ? 'disabled' : '', { 'loading': loading }]"
      :viewBox="viewBox ? '0 0 48 20' : null" @click="onClickButton" preserveAspectRatio="none">
      <title>{{ hint }}</title>
      <g>
        <rect id="main" x="0" y="0" width="100%" height="100%" :fill="fill" stroke="gray" rx="5"></rect>
        <text id="heading_caption" x="50%" y="54%" dominant-baseline='middle' class="unselectable f-text" :style="style"
          lengthAdjust="spacingAndGlyphs" :font-weight="fontStyle">
          {{ heading_caption }}
        </text>
      </g>
    </svg>
    <Dialog v-model:visible="isConfirmDialog" :style="{ width: '550px' }" modal @hide="onEndFunction">
      <template #header>
        <i class="pi pi-question-circle mr-3" style="font-size: 2rem; color: rgb(204,204,0)" />
        <div class="col-10 font-bold text-center" style="font-size: 1.3rem">
          Подтверждение
        </div>
      </template>

      <div class="confirmation-content">
        <div class="text-center">
          <span :style="{ 'font-size': '1.1rem' }"> Подтверждение действия? </span>
        </div>
      </div>
      <template #footer>
        <Button label="Нет" icon="pi pi-times" class="p-button-text" @click="onEndFunction" />
        <Button label="Да" icon="pi pi-check" class="p-button-text" @click="onStartFunction" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import MixinBase from "./mixin-base.js";
import EventBus from "@/core/EventBus";

export default {
  name: "button_",
  mixins: [MixinBase],
  props: {
    heading_caption: {
      type: String,
      default: "",
    },
    fill: {
      type: String,
      default: "#E6E6E6",
    },
    function: {
      type: Function,
    },
    viewBox: {
      type: Boolean,
      default: false,
    },
  },
  unmounted() {
    if (this.interval) clearInterval(this.interval);
  },
  data() {
    return {
      isConfirmDialog: false,
      interval: null,
      style: {
        "font-size": "8pt",
      },
      loading: false
    };
    //TODO: после вызова подтверждения нужно остановить обновление property, что бы не перетерлось введеное/высчитанное значение и тд
  },
  mounted() {
    this.style = {
      "font-size": (localStorage.scale ? localStorage.scale : 14) - 5 + "pt",
    };
  },
  methods: {
    onStartFunction() {
      if (this.function && !this.$store.getters.editMode) {
        if (!this.$store.getters.info.isControl) {
          this.$store.commit("SET_ERROR", {
            er: `Доступ запрещён. У пользователя нет прав на управление объектом "${this.heading_caption}". Обратитесь к администратору.`,
            source: [this.heading_caption],
          });
          this.$store.dispatch(
            "addScriptLog",
            `Нет прав на управление "${this.heading_caption}". Пользователь: ${this.$store.getters.info.login}`
          );
          return;
        }
        try {
          const funct = this.function();
          if (this.isPromise(funct)) {
            this.loading = true;
            funct.finally(() => this.loading = false)
          }
        } catch (error) {
          this.$store.commit("SET_ERROR", {
            er: `Ошибка выполнения команды для "${this.heading_caption}": ${error}.`,
            source: [this.heading_caption],
          });
          this.$store.dispatch(
            "addScriptLog",
            `Ошибка выполнения команды "${this.heading_caption}": ${error}`
          );
        }

        this.isConfirmDialog = false;
      }
      if (!this.function) {
          this.$store.commit("SET_ERROR", {
            er: `Кнопка "${this.heading_caption}" не настроена. Обратитесь к разработчику.`,
            source: [this.heading_caption],
          });
          this.$store.dispatch(
            "addScriptLog",
            `Кнопка "${this.heading_caption}" не имеет назначенной функции.`
          );
      }
    },
    onClickButton() {
      if (this.$store.getters.editMode) return;
      this.isConfirmDialog = true;
      EventBus.emit("on-update-property", false);
      this.interval = setInterval(() => {
        this.isConfirmDialog = false;
        EventBus.emit("on-update-property", true);
      }, 20000);
    },
    onEndFunction() {
      this.isConfirmDialog = false;
      EventBus.emit("on-update-property", true);
      if (this.interval) clearInterval(this.interval);
    },
    isPromise(promise) {
      return promise instanceof Promise || (Boolean(promise) && typeof promise.then === 'function');
    }
  },
};
</script>
<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.f-text {
  text-anchor: middle;
}

.f-text-0 {
  font-size: 5pt;
}

.f-text-1 {
  font-size: 5pt;
}

.f-text-2 {
  font-size: 6pt;
}

.f-text-3 {
  font-size: 7pt;
}

.f-text-4 {
  font-size: 8pt;
}

.button:hover>* {
  opacity: 0.8;
}

.button.loading {
  animation: pulse 1.5s ease-in-out infinite;
  pointer-events: none; // блокируем повторные клики
  opacity: 0.7;
}

@keyframes pulse {
  0% {
    opacity: 0.7;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 0.7;
  }
}
</style>
